<div class="title" data-qa="f-a-b-group">{{ groupTitle() | translate }}</div>
<ng-content/>
